import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from '@angular/router';

import { AuthService } from '@igo2/auth';

import { environment, isPartenaireEnv } from '@env';

@Injectable({
  providedIn: 'root'
})
export class WithAuthGuard {
  private authService = inject(AuthService);
  private router = inject(Router);
  private auth = environment.auth;

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!isPartenaireEnv(environment) || this.authService.logged) {
      return true;
    }

    this.authService.redirectUrl = state.url;
    this.router.navigateByUrl(this.auth!.loginRoute ?? 'auth/login');

    return false;
  }
}
